import React, { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';

import { Resolver } from '../../../core/components';
import { currentVendorIdSelector } from '../../../vendors/services/currentVendorSelector';
import { reportDateSelector } from '../../ducks';
import { DocumentTitle } from '../../../common/components';
import { PageLoading } from '../../../common/components/styled';
import { loadProcessedServices, loadProcessedServicesIssueType } from '../../ducks/processedServices';
// import {RECURRING_SERVICE} from '../../constants'
import ProcessedServicesPage from './ProcessedServicesPage';
import translate from '../../../core/services/translate';
import { AppState } from '../../../store';

interface RouteParams {
  token: string;
}

interface Props extends RouteComponentProps<RouteParams> {
  vendorId?: number;
  date?: string;
  loadProcessedServices(...args: any[]): any;
  loadProcessedServicesIssueType(...args: any[]): any;
}

class ProcessedServicesPageResolver extends PureComponent<Props> {
  loadDependancies = () => {
    const {
      vendorId,
      date,
      loadProcessedServices,
      loadProcessedServicesIssueType,
      match: {
        params: { token },
      },
    } = this.props;

    return Promise.all([loadProcessedServices(vendorId, token, date), loadProcessedServicesIssueType(vendorId, token)]);
  };

  render() {
    return (
      <Fragment>
        <DocumentTitle>{translate('payment.payments')}</DocumentTitle>
        <Resolver
          successComponent={ProcessedServicesPage}
          loadingComponent={PageLoading}
          resolve={this.loadDependancies}
        />
      </Fragment>
    );
  }
}

const mapStateToProps = (state: AppState) => ({
  vendorId: currentVendorIdSelector(state.account.login, state.vendors.defaultVendor),
  date: reportDateSelector(state.payments),
});

const mapDispatchToProps = {
  loadProcessedServices,
  loadProcessedServicesIssueType,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProcessedServicesPageResolver);
